"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repr = void 0;
function repr(token) {
    const { label, value, span } = token;
    return JSON.stringify([label, value, [span.lo, span.hi]]);
}
exports.repr = repr;
//# sourceMappingURL=token-repr.js.map